import Vue from 'vue'
import bookmarkable from '../BookmarkButton/bookmarkable'

export default Vue.extend<any, any, any, any>({
  mixins: [bookmarkable],
})
